unit View.Contadores.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils, UHelperServer, System.StrUtils,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela, UConstantes;

type
  TFViewContadoresList = class(TForm)
    ContadoresDataset: TXDataWebDataSet;
    ContadoresDatasetid: TIntegerField;
    ContadoresDatasetnome: TStringField;
    ContadoresDatasetemail: TStringField;
    ContadoresDatasetcnpj: TStringField;
    ContadoresDatasetendereco: TStringField;
    ContadoresDatasetbairro: TStringField;
    ContadoresDatasetnumero: TStringField;
    ContadoresDatasetcomplemento: TStringField;
    ContadoresDatasetcep: TStringField;
    ContadoresDatasettelefone: TStringField;
    ContadoresDatasetcodigo_interno: TIntegerField;
    ContadoresDatasetexcluido: TBooleanField;
    ContadoresDatasetinclusao: TDateTimeField;
    ContadoresDatasetalteracao: TDateTimeField;
    ContadoresDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    ContadoresDatasetcidadeNome: TStringField;
    ContadoresDatasetcidadeufSigla: TStringField;
    edtCidadeNome: TEdit;
    btnPesquisarCidade: TButton;
    btnExportarExcel: TButton;
    ContadoresDatasetquantidade_clientes: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure ContadoresDatasetcnpjGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasetcepGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasetenderecoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasetemailGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ContadoresDatasettelefoneGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure ContadoresDatasetcidadeNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    [async]
    procedure btnPesquisarCidadeClick(Sender: TObject); async;
    procedure btnExportarExcelClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    function GetFiltro : string;
    procedure Filtrar;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewContadoresList: TFViewContadoresList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewContadoresList }

procedure TFViewContadoresList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(ContadoresDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewContadoresList.btnPesquisarCidadeClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtCidadeNome.Tag;
  Await(THelperServer.ChamarConsulta('Cidades', 'Cidade', edtCidadeNome));

  if lBackupTag <> edtCidadeNome.Tag then
    Filtrar;
end;

procedure TFViewContadoresList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewContadoresList.ContadoresDatasetcepGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCEP(Sender.AsString);
end;

procedure TFViewContadoresList.ContadoresDatasetcidadeNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, ContadoresDataset.FieldByName('cidade.uf.Sigla').AsString);
end;

procedure TFViewContadoresList.ContadoresDatasetcnpjGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewContadoresList.ContadoresDatasetemailGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := UpperCase(Sender.AsString);
end;

procedure TFViewContadoresList.ContadoresDatasetenderecoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarEndereco(Sender.AsString, ContadoresDataset.FieldByName('numero').AsString,
    ContadoresDataset.FieldByName('bairro').AsString, EmptyStr);
end;

procedure TFViewContadoresList.ContadoresDatasettelefoneGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarTelefone(Sender.AsString);
end;

class function TFViewContadoresList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewContadoresList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewContadoresList, AElementID, Result, @AfterCreate);
end;

procedure TFViewContadoresList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewContadoresList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewContadoresList.Filtrar;
begin
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.Load;
end;

function TFViewContadoresList.GetFiltro: string;
begin
  Result := EmptyStr;

  if edtCidadeNome.Tag <> 0 then
    Result := '(cidade_id eq '+edtCidadeNome.Tag.ToString+')'
end;

procedure TFViewContadoresList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewContadoresList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ContadoresDataset.Connection.Model.DefaultSchema.FindEntityType(ContadoresDataset.EntitySetName),
      ContadoresDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_contador');
  end;
end;

procedure TFViewContadoresList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome', 'cnpj',
      'email', 'telefone', 'cidade.Nome', 'endereco']) of
      0, 1, 2, 3, 4, 5: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewContadoresList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow = 0 then
    Exit;

  case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
    0:
    begin
      if AValue = 'True' then
        AValue := '<i class="fas fa-check text-success"><i>'
      else if AValue = 'False' then
        AValue := '<i class="fas fa-times text-danger"><i>';
    end;
  end;
end;

procedure TFViewContadoresList.WebFormCreate(Sender: TObject);
var
  lIndexColunaQtdeClientes : Integer;
begin
  if not TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
  begin
    lIndexColunaQtdeClientes := TUtils.GetIndexColunaPeloTitulo(WebDBTableControl1, 'Qtde. Clientes');
    WebDBTableControl1.Columns.Delete(lIndexColunaQtdeClientes);
    ContadoresDataset.FieldByName('quantidade_clientes').Tag := 1;
  end;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('contadores', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, ContadoresDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'nome';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewContadoresList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.contadores.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.contadores.list.table');
  cbPageSize := TComboBox.Create('view.contadores.list.cbPageSize');
  edSearch := TEdit.Create('view.contadores.list.search');
  lcPaginator := TListControl.Create('view.contadores.list.pagination');
  edtCidadeNome := TEdit.Create('edtCidadeNome');
  btnPesquisarCidade := TButton.Create('btnPesquisarCidade');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  ContadoresDataset := TXDataWebDataSet.Create(Self);
  ContadoresDatasetcodigo_interno := TIntegerField.Create(Self);
  ContadoresDatasetnome := TStringField.Create(Self);
  ContadoresDatasetcnpj := TStringField.Create(Self);
  ContadoresDatasetquantidade_clientes := TIntegerField.Create(Self);
  ContadoresDatasettelefone := TStringField.Create(Self);
  ContadoresDatasetemail := TStringField.Create(Self);
  ContadoresDatasetcidadeNome := TStringField.Create(Self);
  ContadoresDatasetcidadeufSigla := TStringField.Create(Self);
  ContadoresDatasetcep := TStringField.Create(Self);
  ContadoresDatasetendereco := TStringField.Create(Self);
  ContadoresDatasetbairro := TStringField.Create(Self);
  ContadoresDatasetnumero := TStringField.Create(Self);
  ContadoresDatasetcomplemento := TStringField.Create(Self);
  ContadoresDatasetexcluido := TBooleanField.Create(Self);
  ContadoresDatasetinclusao := TDateTimeField.Create(Self);
  ContadoresDatasetalteracao := TDateTimeField.Create(Self);
  ContadoresDatasetexclusao := TDateTimeField.Create(Self);
  ContadoresDatasetid := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  edtCidadeNome.BeforeLoadDFMValues;
  btnPesquisarCidade.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  ContadoresDataset.BeforeLoadDFMValues;
  ContadoresDatasetcodigo_interno.BeforeLoadDFMValues;
  ContadoresDatasetnome.BeforeLoadDFMValues;
  ContadoresDatasetcnpj.BeforeLoadDFMValues;
  ContadoresDatasetquantidade_clientes.BeforeLoadDFMValues;
  ContadoresDatasettelefone.BeforeLoadDFMValues;
  ContadoresDatasetemail.BeforeLoadDFMValues;
  ContadoresDatasetcidadeNome.BeforeLoadDFMValues;
  ContadoresDatasetcidadeufSigla.BeforeLoadDFMValues;
  ContadoresDatasetcep.BeforeLoadDFMValues;
  ContadoresDatasetendereco.BeforeLoadDFMValues;
  ContadoresDatasetbairro.BeforeLoadDFMValues;
  ContadoresDatasetnumero.BeforeLoadDFMValues;
  ContadoresDatasetcomplemento.BeforeLoadDFMValues;
  ContadoresDatasetexcluido.BeforeLoadDFMValues;
  ContadoresDatasetinclusao.BeforeLoadDFMValues;
  ContadoresDatasetalteracao.BeforeLoadDFMValues;
  ContadoresDatasetexclusao.BeforeLoadDFMValues;
  ContadoresDatasetid.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewContadoresList';
    Width := 544;
    Height := 380;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 320;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cnpj';
      Title := 'Documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_clientes';
      Title := 'Qtde. Clientes';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefone';
      Title := 'telefone';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'email';
      Title := 'email';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cidade.Nome';
      Title := 'Cidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cep';
      Title := 'cep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'endereco';
      Title := 'Endere'#231'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 309;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    edtCidadeNome.SetParentComponent(Self);
    edtCidadeNome.Name := 'edtCidadeNome';
    edtCidadeNome.Left := 242;
    edtCidadeNome.Top := 344;
    edtCidadeNome.Width := 120;
    edtCidadeNome.Height := 22;
    edtCidadeNome.ChildOrder := 21;
    edtCidadeNome.Enabled := False;
    edtCidadeNome.HeightPercent := 100.000000000000000000;
    edtCidadeNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCidade.SetParentComponent(Self);
    btnPesquisarCidade.Name := 'btnPesquisarCidade';
    btnPesquisarCidade.Left := 363;
    btnPesquisarCidade.Top := 344;
    btnPesquisarCidade.Width := 30;
    btnPesquisarCidade.Height := 22;
    btnPesquisarCidade.ChildOrder := 22;
    btnPesquisarCidade.HeightPercent := 100.000000000000000000;
    btnPesquisarCidade.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCidade, Self, 'OnClick', 'btnPesquisarCidadeClick');
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 416;
    btnExportarExcel.Top := 340;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    ContadoresDataset.SetParentComponent(Self);
    ContadoresDataset.Name := 'ContadoresDataset';
    ContadoresDataset.EntitySetName := 'Contadores';
    ContadoresDataset.Connection := DMConnection.ApiConnection;
    ContadoresDataset.Left := 72;
    ContadoresDataset.Top := 88;
    ContadoresDatasetcodigo_interno.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcodigo_interno.Name := 'ContadoresDatasetcodigo_interno';
    ContadoresDatasetcodigo_interno.FieldName := 'codigo_interno';
    ContadoresDatasetcodigo_interno.Required := True;
    ContadoresDatasetnome.SetParentComponent(ContadoresDataset);
    ContadoresDatasetnome.Name := 'ContadoresDatasetnome';
    ContadoresDatasetnome.FieldName := 'nome';
    ContadoresDatasetnome.Required := True;
    ContadoresDatasetnome.Size := 255;
    ContadoresDatasetcnpj.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcnpj.Name := 'ContadoresDatasetcnpj';
    ContadoresDatasetcnpj.FieldName := 'cnpj';
    SetEvent(ContadoresDatasetcnpj, Self, 'OnGetText', 'ContadoresDatasetcnpjGetText');
    ContadoresDatasetcnpj.Size := 255;
    ContadoresDatasetquantidade_clientes.SetParentComponent(ContadoresDataset);
    ContadoresDatasetquantidade_clientes.Name := 'ContadoresDatasetquantidade_clientes';
    ContadoresDatasetquantidade_clientes.Tag := 3;
    ContadoresDatasetquantidade_clientes.FieldName := 'quantidade_clientes';
    ContadoresDatasettelefone.SetParentComponent(ContadoresDataset);
    ContadoresDatasettelefone.Name := 'ContadoresDatasettelefone';
    ContadoresDatasettelefone.FieldName := 'telefone';
    SetEvent(ContadoresDatasettelefone, Self, 'OnGetText', 'ContadoresDatasettelefoneGetText');
    ContadoresDatasettelefone.Size := 255;
    ContadoresDatasetemail.SetParentComponent(ContadoresDataset);
    ContadoresDatasetemail.Name := 'ContadoresDatasetemail';
    ContadoresDatasetemail.FieldName := 'email';
    SetEvent(ContadoresDatasetemail, Self, 'OnGetText', 'ContadoresDatasetemailGetText');
    ContadoresDatasetemail.Size := 255;
    ContadoresDatasetcidadeNome.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcidadeNome.Name := 'ContadoresDatasetcidadeNome';
    ContadoresDatasetcidadeNome.FieldName := 'cidade.Nome';
    SetEvent(ContadoresDatasetcidadeNome, Self, 'OnGetText', 'ContadoresDatasetcidadeNomeGetText');
    ContadoresDatasetcidadeufSigla.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcidadeufSigla.Name := 'ContadoresDatasetcidadeufSigla';
    ContadoresDatasetcidadeufSigla.Tag := 3;
    ContadoresDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    ContadoresDatasetcep.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcep.Name := 'ContadoresDatasetcep';
    ContadoresDatasetcep.FieldName := 'cep';
    ContadoresDatasetcep.Required := True;
    SetEvent(ContadoresDatasetcep, Self, 'OnGetText', 'ContadoresDatasetcepGetText');
    ContadoresDatasetcep.Size := 255;
    ContadoresDatasetendereco.SetParentComponent(ContadoresDataset);
    ContadoresDatasetendereco.Name := 'ContadoresDatasetendereco';
    ContadoresDatasetendereco.FieldName := 'endereco';
    SetEvent(ContadoresDatasetendereco, Self, 'OnGetText', 'ContadoresDatasetenderecoGetText');
    ContadoresDatasetendereco.Size := 255;
    ContadoresDatasetbairro.SetParentComponent(ContadoresDataset);
    ContadoresDatasetbairro.Name := 'ContadoresDatasetbairro';
    ContadoresDatasetbairro.Tag := 3;
    ContadoresDatasetbairro.FieldName := 'bairro';
    ContadoresDatasetbairro.Size := 255;
    ContadoresDatasetnumero.SetParentComponent(ContadoresDataset);
    ContadoresDatasetnumero.Name := 'ContadoresDatasetnumero';
    ContadoresDatasetnumero.Tag := 3;
    ContadoresDatasetnumero.FieldName := 'numero';
    ContadoresDatasetnumero.Size := 255;
    ContadoresDatasetcomplemento.SetParentComponent(ContadoresDataset);
    ContadoresDatasetcomplemento.Name := 'ContadoresDatasetcomplemento';
    ContadoresDatasetcomplemento.Tag := 3;
    ContadoresDatasetcomplemento.FieldName := 'complemento';
    ContadoresDatasetcomplemento.Size := 255;
    ContadoresDatasetexcluido.SetParentComponent(ContadoresDataset);
    ContadoresDatasetexcluido.Name := 'ContadoresDatasetexcluido';
    ContadoresDatasetexcluido.FieldName := 'excluido';
    ContadoresDatasetinclusao.SetParentComponent(ContadoresDataset);
    ContadoresDatasetinclusao.Name := 'ContadoresDatasetinclusao';
    ContadoresDatasetinclusao.FieldName := 'inclusao';
    ContadoresDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ContadoresDatasetalteracao.SetParentComponent(ContadoresDataset);
    ContadoresDatasetalteracao.Name := 'ContadoresDatasetalteracao';
    ContadoresDatasetalteracao.FieldName := 'alteracao';
    ContadoresDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ContadoresDatasetexclusao.SetParentComponent(ContadoresDataset);
    ContadoresDatasetexclusao.Name := 'ContadoresDatasetexclusao';
    ContadoresDatasetexclusao.FieldName := 'exclusao';
    ContadoresDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ContadoresDatasetid.SetParentComponent(ContadoresDataset);
    ContadoresDatasetid.Name := 'ContadoresDatasetid';
    ContadoresDatasetid.Tag := 1;
    ContadoresDatasetid.FieldName := 'id';
    ContadoresDatasetid.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ContadoresDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 144;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 400;
    tmrConsulta.Top := 128;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    edtCidadeNome.AfterLoadDFMValues;
    btnPesquisarCidade.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    ContadoresDataset.AfterLoadDFMValues;
    ContadoresDatasetcodigo_interno.AfterLoadDFMValues;
    ContadoresDatasetnome.AfterLoadDFMValues;
    ContadoresDatasetcnpj.AfterLoadDFMValues;
    ContadoresDatasetquantidade_clientes.AfterLoadDFMValues;
    ContadoresDatasettelefone.AfterLoadDFMValues;
    ContadoresDatasetemail.AfterLoadDFMValues;
    ContadoresDatasetcidadeNome.AfterLoadDFMValues;
    ContadoresDatasetcidadeufSigla.AfterLoadDFMValues;
    ContadoresDatasetcep.AfterLoadDFMValues;
    ContadoresDatasetendereco.AfterLoadDFMValues;
    ContadoresDatasetbairro.AfterLoadDFMValues;
    ContadoresDatasetnumero.AfterLoadDFMValues;
    ContadoresDatasetcomplemento.AfterLoadDFMValues;
    ContadoresDatasetexcluido.AfterLoadDFMValues;
    ContadoresDatasetinclusao.AfterLoadDFMValues;
    ContadoresDatasetalteracao.AfterLoadDFMValues;
    ContadoresDatasetexclusao.AfterLoadDFMValues;
    ContadoresDatasetid.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
